import React, { useEffect, useMemo } from "react";
import SequenceLanding from "../component/sequenceLanding";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  QR_LANDING_PAGE_INSPECTION_REPORT,
  QR_LANDING_PAGE_PERMITS,
  QR_LANDING_PAGE_RESOURCES,
  QR_LANDING_PAGE_SAMPLINGLOGS,
  QR_LANDING_PAGE_RAINFALL,
} from "../../constant/routeContant";
import * as sequenceLandingAction from "../../redux/actions/sequenceLandingAction";
import { API_STATUS } from "../../constant/constant";
import Loader from "../../library/common/Loader";

const SequenceLandingContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const parsedData = useMemo(() => {
    try {
      const data = new URLSearchParams(window.location.search).get("data");
      return data ? JSON.parse(decodeURIComponent(data)) : null;
    } catch {
      return null;
    }
  }, []);

  // QR stickers printed before the project id was carried into the payload
  // encode id: null. The project number is still correct on those stickers, so
  // resolve the id from it rather than letting every card query on nothing.
  const projectNumber = parsedData?.projectNumber;
  const needsLookup = !parsedData?.id && !!projectNumber;

  const projectByNumber = useSelector(
    (state) => state.sequenceLandingProjectByNumber
  );
  const resolvedId = projectByNumber?.data?.result?.projectId;
  const lookupSettled =
    projectByNumber?.status === API_STATUS.SUCCESS ||
    projectByNumber?.status === API_STATUS.FAILURE;

  useEffect(() => {
    if (needsLookup) {
      dispatch(
        sequenceLandingAction.getSequenceLandingProjectByNumber({
          projectNumber,
        })
      );
    }
  }, []);

  const isResolving = needsLookup && !resolvedId && !lookupSettled;

  const onClickHandler = (id, paramas) => {
    // Hold a tap that lands while the lookup is still in flight; once it has
    // settled, fall through with whatever we have so an unresolvable number
    // behaves no worse than it did before.
    if (isResolving) return;

    const paramasWithId = paramas?.id
      ? paramas
      : { ...paramas, id: resolvedId ?? paramas?.id };

    if (id === 1) {
      navigate(QR_LANDING_PAGE_INSPECTION_REPORT, { state: paramasWithId });
    } else if (id === 2) {
      navigate(QR_LANDING_PAGE_RESOURCES, { state: paramasWithId });
    } else if (id === 3) {
      navigate(QR_LANDING_PAGE_PERMITS, { state: paramasWithId });
    } else if (id === 4) {
      navigate(QR_LANDING_PAGE_SAMPLINGLOGS, { state: paramasWithId });
    } else if (id === 5) {
      navigate(QR_LANDING_PAGE_RAINFALL, { state: paramasWithId });
    }
  };

  return (
    <>
      {isResolving && <Loader />}
      <SequenceLanding onClickHandler={onClickHandler} />
    </>
  );
};

export default SequenceLandingContainer;
